define('drops/dateInput/dateInput',[
    'jquery',
    'underscore',
    'globalize',
    'lq/drop',
    'lq/enum',
    'lq/constants',
    'lq/responsive',
    'lq/util',
    'lq',
    './dateInputCustom',
    './dateInputNative',
    'lq/required'
], function ($, _, globalize, Drop, Enum, constants, responsive, util, lq, DateInputCustom, DateInputNative, Required) {
    'use strict';

    var defaults = {
        data: {
            showDatePicker: true,
            showTimePicker: false,
            todayLabel: 'Today',
            clearLabel: 'Clear',
            timeInputStep: 30,
            lightBoxOpacity: 100,
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            },
            precision: 'day',
            defaultMonth: 1,
            defaultDay: 1,
            defaultDaySource: 'hardcoded',
            defaultMonthSource: 'hardcoded'
        }
    };

    function DateInput(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing) || {};

        this.date = null;

        this.$element
            .addClass('boxToBorderSize')
            .css({
                whiteSpace: 'pre-wrap'
            });

        this.minDateFormatted = globalize.parseDate(this.data.minDate, this.minMaxDateFormat);
        this.maxDateFormatted = globalize.parseDate(this.data.maxDate, this.minMaxDateFormat);
    }

    Drop.extend(DateInput, Drop);

    DateInput.typeName = 'DateInput';

    DateInput.prototype.minMaxDateFormat = 'yyyy-MM-dd';

    DateInput.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        Required.prototype.addRemoveRequiredIndicator(this);

        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);

        this.input = this.shouldShowCustomInput()
            ? new DateInputCustom(this, this.formatter)
            : new DateInputNative(this);

        this.input.initialize();

        this.applyPosition();
    };

    DateInput.prototype.shouldShowCustomInput = function () {
        var dateInputBehaviour = this.rootDrop.options.dateInputBehaviour;
        return dateInputBehaviour === 0 || (dateInputBehaviour === 1 && !responsive.isPhoneDevice());
    };

    DateInput.prototype.focus = function () {
        this.input.focus();
    };

    DateInput.prototype.getValue = function () {
        return this.getCurrentDateAsLicquidDate();
    };

    DateInput.prototype.clearValue = function () {
        this.date = null;
        this.input.clearValue();
        this.updateRequiredIndicator();
    };

    DateInput.prototype.setValue = function (update) {
        if (update.value) {
            this.date = globalize.parseDate(update.value, constants.licquidDateFormat);

            if (!this.data.showTimePicker)
                this.date.setHours(0, 0, 0, 0);

            this.input.setValue(this.date);
        } else {
            this.date = null;
            this.input.clearValue();
        }

        this.updateRequiredIndicator();
    };

    DateInput.prototype.dateChanged = function (date1, date2) {
        if (!date1 || !date2)
            return date1 !== date2;

        return date1.getYear() !== date2.getYear()
            || date1.getMonth() !== date2.getMonth()
            || date1.getDate() !== date2.getDate();
    };

    DateInput.prototype.timeChanged = function (date1, date2) {
        if (!date1 || !date2)
            return date1 !== date2;

        return date1.getHours() !== date2.getHours()
            || date1.getMinutes() !== date2.getMinutes()
            || date1.getSeconds() !== date2.getSeconds();
    };

    DateInput.prototype.updateDate = function (newDate) {
        var newDateWithoutTime = null;
        if (newDate) {
            newDateWithoutTime = new Date(newDate);
            if (this.data.showTimePicker) {
                newDateWithoutTime.setHours(0, 0, 0, 0);
            }
        }
        if (this.data.minDate && newDateWithoutTime) {
            if (this.minDateFormatted && newDateWithoutTime < this.minDateFormatted) {
                newDate = null;
                this.triggerEventIfEnabled('minMaxDateNotValid');
            }
        }
        if (this.data.maxDate && newDateWithoutTime) {
            if (this.maxDateFormatted && newDateWithoutTime > this.maxDateFormatted) {
                newDate = null;
                this.triggerEventIfEnabled('minMaxDateNotValid');
            }
        }
        if (newDate) {
            var hasTimeChange = this.timeChanged(this.date, newDate);
            var hasDateChange = this.dateChanged(this.date, newDate);

            this.date = newDate;

            this.input.afterDateUpdatedSuccesfully(newDate);

            var licquidDate = this.formatter.formatLicquidDate(newDate);

            if (hasTimeChange || hasDateChange) {
                this.triggerEventIfEnabled('selected', licquidDate);
                this.triggerEventIfEnabled('changed', licquidDate);
            }

            if (hasTimeChange) {
                this.triggerEventIfEnabled('timeSelected', licquidDate);
                this.triggerEventIfEnabled('timeChanged', licquidDate);
            }

            if (hasDateChange) {
                this.triggerEventIfEnabled('dateSelected', licquidDate);
                this.triggerEventIfEnabled('dateChanged', licquidDate);
            }
        } else {
            var hadDate = !!this.date;

            this.date = null;

            this.input.clearValue();

            if (hadDate) {
                this.triggerEventIfEnabled('deselected');
                this.triggerEventIfEnabled('changed');
                this.triggerEventIfEnabled('timeChanged');
                this.triggerEventIfEnabled('dateChanged');
            }
        }

        this.updateRequiredIndicator();
    };

    DateInput.prototype.getCurrentDateAsLicquidDate = function () {
        if (!this.date) return null;
        return this.formatter.formatLicquidDate(this.date);
    };

    return DateInput;
});

